// extracted by mini-css-extract-plugin
module.exports = {"tagsList":"tags-picker_tagsList__13ZsL","chip":"tags-picker_chip__2zNbM"};